import AxiosInterceptor from "../utils/AxiosInterceptor";

const apiUsers = {
  add: (value) => AxiosInterceptor().post(`/add-creator`, value),
  edit: (value) => AxiosInterceptor().post(`/update-creator`, value),
  editC: (value) => AxiosInterceptor().post(`/update-customer`, value),
  getAll: (values) => AxiosInterceptor().post(`/get-all-user`, values),
  getById: (values) => AxiosInterceptor().post(`/get-user`, values),
  changeStatus: (values) =>
    AxiosInterceptor().post(`/block-unblock-user`, values),
  documentVerification: (values) =>
    AxiosInterceptor().post(`/creator-verify`, values),
};

export default apiUsers;
